module.exports = __webpack_public_path__ + "static/media/aller_media.ad7d6f8a.png";